import { hide } from 'redux-modal'
import { push } from 'connected-react-router'
import { ADD_TO_QUOTE_MODAL } from 'constant'

export const continueShopping = () => hide(ADD_TO_QUOTE_MODAL)

export const navigateToQuote = path => dispatch => {
  dispatch(hide(ADD_TO_QUOTE_MODAL))
  setTimeout(() => dispatch(push(path)))
}
